import {  useContext, useState } from 'react';
import { useNavigate } from "react-router-dom";
import clsx from 'clsx';
import '../Profile.css'
import { AppGeneralContext } from '../../../../shared/GeneralContext/GeneralContext';
import useMediaQuery from '../../../../hook/useMediaQuery';
import { MediaDesktop, MediaMobile, MediaTablet } from '../../../../api/const/MediaQuery';






export const ProfileCorporateEdit = () => {
    const [isEditView, setIsEditView] = useState<boolean>(false)
    const tablet = useMediaQuery(MediaTablet)
    const mobile = useMediaQuery(MediaMobile)
    const desktop = useMediaQuery(MediaDesktop)
    const navigate = useNavigate()
    const { user} = useContext(AppGeneralContext)


    return (

        <div className={clsx(" m-0 p-0  container-fluid ", {
            "me-5": !tablet,
            "me-3": tablet
        })}>
            <div className={clsx("row d-flex m-0 p-0 align-items-center flex-wrap pe-3 pb-0", {
                "mt-5": !tablet,
                "mt-3": tablet
            })}>
                <div className={clsx('d-flex m-0 p-0', {
                    " col-7": !tablet,
                    " col-6": (tablet && !mobile),
                    " col-12": (tablet && mobile)
                })}>
                    <h3>Hi <span className='tx-primary'>{user?.firstName} {user?.lastName},</span></h3>
                </div>
                <div className=' m-0 p-0'>
                    <h5 className="corporate-subtitle"> {user?.jobTitle} at {user?.role?.name} | {user?.department?.label} </h5>
                </div>
            </div>

        </div>

    );
}

